'use strict';
//import "intl";
//import "intl-messageformat";

import angular from "angular";
import moment from "./moment";
import lodash from "./lodash.js";
import ConfigService from "./ConfigService";
import MaintenanceService from "app/services/MaintenanceService";
import Events from "./Events";

class LocaleService {

  constructor($locale, $window, $rootScope, Events, ConfigService, $http, $q, _, $state, moment, MaintenanceService) {

    this.TOKEN_REGEX = new RegExp('^[\\w\\.-]+\\.[\\w\\s\\.-]+\\w(:.*)?$');
    this.strings = {};
    this.dateFromats = {};
    this.locales = null;
    this.currentLocale = undefined;
    this.$locale = $locale;
    this.$window = $window;
    this.ConfigService = ConfigService;
    this.$http = $http;
    this.$q = $q;
    this.loadedLocale = null;
    this.$state = $state;
    this._ = _;
    //this.amMoment = amMoment;
    ///this.tmhDynamicLocale = tmhDynamicLocale;
    this.$rootScope = $rootScope;
    this.Events = Events;
    this.moment = moment;
    this.MaintenanceService = MaintenanceService;

    //this.DemoModeService = DemoModeService;

    this.dateFormats = {};
    this.moneyFormats = {};

  }

  formatMoneyFunc(a, _c, _d, _t) {
    var n = a;
    var c, d, t, s, i, j;

    c = isNaN(c = Math.abs(_c)) ? 2 : c;
    d = _d === undefined ? "." : _d;
    t = _t === undefined ? "," : _t;

    s = n < 0 ? "-" : "";
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;

    return "\u00A4 " + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  }

  formatMoney(money, nullable, currencySymbol, fractionSize) {

    if (this.ConfigService.get("localCurrency", true)) {
      currencySymbol = this.ConfigService.get("localCurrency");
    }

    var amount; // = 0;

    if (false) { //this.DemoModeService.isDemoModeEnabled()) {
      return "**.***,**";
    }
    else {

      if (money && money.value) {
        amount = money.value;
        currencySymbol = money.currency.code || currencySymbol;

      }
      else {
        if (!nullable) {
          amount = 0;
        }
        else {
          return null;
        }
      }

      if (angular.isUndefined(currencySymbol)) {
        currencySymbol = "EUR" || this.getCurrencySymbol();
      }

      if (angular.isUndefined(fractionSize)) {
        fractionSize = this.getFractionSize();
      }

      if (currencySymbol == "EUR") {
        currencySymbol = "€";
      }

      if (currencySymbol == "USD") {
        currencySymbol = "$";
      }

      // if null or undefined pass it through
      return (amount === null) ? amount : this.formatMoneyFunc(amount, fractionSize, this.getDecimalSeparator(), this.getThousandsSeparator()).replace(/\u00A4/g, currencySymbol);
    }
  }

  formatDate(date, format, preventWarning) {
    if (date && this.moment(date).isValid()) {
      var d = this.moment(date);
      //console.log("date: ", date, ", format: ", format,"=", this.getDateFormat(format), ": ", d.format(this.getDateFormat(format)));
      if (this.getDateFormat(format)) {
        return d.format(this.getDateFormat(format));
      } else {
        return d.format(format);
      }
    } else {
      if (!this.moment(date).isValid() && !preventWarning) {
        console.warn("invalid date: ", date);
      }
      return date;
    }
  }

  getDateFormat(name) {
    return this.dateFormats["format.date.moment." + name]; // this.$locale.DATETIME_FORMATS[name];
  }

  getDecimalSeparator() {
    return this.moneyFormats["format.money.DECIMAL_SEPARATOR"];
  }

  getThousandsSeparator() {
    return this.moneyFormats["format.money.THOUSANDS_SEPARATOR"];
  }

  getFractionSize() {
    return this.moneyFormats["format.money.FRACTION_SIZE"];
  }

  getCurrencySymbol() {
    return this.moneyFormats["format.money.CURRENCY_SYMBOL"];
  }

  getKeyForSyscode(syscodeGroup, syscode) {
    return "dot.syscodes." + syscodeGroup + "." + syscode;
  }

  isToken(str) {
    return (str && str.length && this.TOKEN_REGEX.test(str));
  }

  setCommonParams(text, params) {
    if (text.indexOf("{br}") >= 0) {
      params.br = "<br>";
    }
    if (text.indexOf("{small}") >= 0) {
      params.small = "<small>";
    }
    if (text.indexOf("{smallend}") >= 0) {
      params.smallend = "</small>";
    }
    if (text.indexOf("{bold}") >= 0) {
      params.bold = "<b>";
    }
    if (text.indexOf("{boldend}") >= 0) {
      params.boldend = "</b>";
    }
    if (text.indexOf("{italic}") >= 0) {
      params.italic = "<i>";
    }
    if (text.indexOf("{italicend}") >= 0) {
      params.italicend = "</i>";
    }
    if (text.indexOf("{underlined}") >= 0) {
      params.underlined = "<u>";
    }
    if (text.indexOf("{underlinedend}") >= 0) {
      params.underlinedend = "</u>";
    }
    if (text.indexOf("{div}") >= 0) {
      params.div = "<div>";
    }
    if (text.indexOf("{divend}") >= 0) {
      params.divend = "</div>";
    }
    return params;
  }

  getString(key, params) {
    return this.get(key, params);
  }

  formatMessage(msgtext, params) {
    let newparams;
    if (params) {
      newparams = this.setCommonParams(msgtext, params);
    }
    else {
      newparams = this.setCommonParams(msgtext, {});
    }

    newparams.a = content => `<a href="${content}" target="_blank">${content}</a>`;

    try {
      if (Object.keys(newparams).length > 0) {
        return new IntlMessageFormat(msgtext).format(newparams);
      } else {
        return msgtext;
      }
    }
    catch (e) {
      // console.log("ERROR: " + key + " - " + msgtext + ":" + e.message);
      return msgtext;
    }

  }

  get(key, params) {
    if (key !== undefined) {
      if (key.trim !== undefined) {
        key = key.trim();
      }
      var context = this.ConfigService.get("context");

      if (context) {
        var contextkey = key + "." + context.toLowerCase();
        if (this.strings[contextkey]) {
          key = contextkey;
        }
      }

      if (this.strings[key]) {
        if (this.ConfigService.get("i18n.debug", true, false)) {
          return key;
        }
        else {
          return this.formatMessage(this.strings[key], params);
        }
      }
      else {
        // console.log("Missing i18n for: ", key);
        return "!" + key + "!";
      }
    }
    return "";
  }

  setFormats(formats) {
    //this.dateFormats = formats;
    //angular.extend(this.$locale.DATETIME_FORMATS, this.dateFormats);
  }

  setAll(_strings) {
    this.strings = _strings;
  }

  addAll(_strings) {
    _.assign(this.strings, _strings);
  }

  set(key, value) {
    this.strings[key] = value;
  }

  getListByRegexp(key) {
    var regexp = new RegExp(key);
    var keys = Object.keys(this.strings).filter((elem) => { return regexp.test(elem); });
    return _.pick(this.strings, keys);
  }

  remove(key) {
    this.strings[key] = undefined;
    delete strings[key];
  }

  //changeLocale(currentLocale); --> dont do this here, first call to change locale should be done in app.run in index.html
  //because the custom formats will be overwritten if not explicitly defined
  //we are starting with german -> then switch to english -> custom format is not known..

  getLocales() {
    if (this.locales === undefined || this.locales === null) {
      this.locales = this.ConfigService.get("i18n.locales", true, {
        "de-AT": {
          code: "de",
          active: true
        }
      });
      this.locales = _.pick(this.locales, this.ConfigService.get("i18n.languages", true, ["de-AT"]));
    }
    return this.locales;
  }

  changeLocale(id) {

    //this.amMoment.changeLocale(id);
    this.moment.locale(id.split("-")[0]);
    this.locales = this.getLocales();
    //TODO: change locale of amMoment for timeago directives
    this.setLanguagesInactive();
    if (this.locales[id]) {
      this.locales[id].active = true;
      this.currentLocale = id;
    }
    else {
      var fallback = this.ConfigService.get("i18n.languageFallbacks", true) ? this.ConfigService.get("i18n.languageFallbacks", true)[id] || "de-AT" : "de-AT";
      this.locales[fallback].active = true;
      this.currentLocale = fallback;
    }

    //console.log("DATE FORMATS ", this.dateFormats);

    this.$rootScope.$emit(this.Events.USER_CHANGED);

    return; // $q.resolve(); //this.tmhDynamicLocale.set(id.toLowerCase());
    //angular.extend(this.$locale.DATETIME_FORMATS, this.dateFormats);
  }

  switchLocale(id) {
    this.changeLocale(id);
    var params = this._.assign(this.$state.params, { locale: id });
    this.$state.go(this.$state.current.name, params, { reload: true, notify: true });
    //this.$state.go(this.$state.current.name, params, {reload: true});
    setTimeout(() => {
      this.$window.location.reload();
    }, 100);
  }

  getCurrentLocale() {
    return this.currentLocale;
  }

  getLocale() {
    return this.currentLocale;
  }

  setLanguagesInactive() {
    var languages = Object.keys(this.getLocales());
    for (var i = 0; i < languages.length; i++) {
      this.locales[languages[i]].active = false;
    }
  }

  getLocaleUrl(localeId) {
    var params = _.assign(this.$state.params, { locale: localeId });
    return this.$state.href(this.$state.current.name, params, { absolute: true });
  }

  loadStrings(locale) {
    locale = this.ConfigService.get("i18n.languageFallbacks." + locale, true) || locale;

    return this.$q((resolve, reject) => {
      if (this.loadedLocale === locale) {
        this.changeLocale(locale);
        resolve(locale);
        //console.log("resolve loaded locale");
        //resolve(locale);
      } else {
        if (locale) {
          this.$http.get("/" + locale + "/descriptions").then((res) => {
            var translations = res.data.descriptions;
            _.keys(translations).forEach((key) => this.set(key, translations[key]));
            this.loadedLocale = locale;
            //console.log("loaded translations for locale: ", this.loadedLocale, res.data);
            //this.setFormats(res.data.dateFormats);
            this.dateFormats = res.data.dateFormats;
            this.moneyFormats = res.data.moneyFormats;
            //this.amMoment.changeLocale(locale,res.data.momentData);
            this.moment.locale(locale.split("-")[0]);

            this.changeLocale(locale);
            resolve(locale);
          }, (err) => {
            //console.error("ERROR: ", err);
            this.MaintenanceService.showGlobalError();
            /*if (this.$window.location.pathname !== "/error") {
              this.$window.location = "/error";
            }*/
            //$state.go("staticError",{},{reload : true});
            reject(err);
          });
        }
        else {
          var err = new Error("locale is not defined");
          console.error("ERROR: ", err);
          reject(err);
        }
      }
    });
  }
}

LocaleService.$inject = ["$locale", "$window", "$rootScope", "Events", "ConfigService", "$http", "$q", "_", "$state", "moment", "MaintenanceService"];

export default angular.module("services.LocaleService", [ConfigService, moment, Events, ConfigService, MaintenanceService, lodash])
  .service("LocaleService", LocaleService)
  .name;



// WEBPACK FOOTER //
// ./src/ui/app/services/LocaleService.js